var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 1.33398V4.00065H19.9998V1.33398H22.6665V4.00065H27.9998C28.3535 4.00065 28.6926 4.14113 28.9426 4.39118C29.1927 4.64122 29.3332 4.98036 29.3332 5.33398V26.6673C29.3332 27.0209 29.1927 27.3601 28.9426 27.6101C28.6926 27.8602 28.3535 28.0006 27.9998 28.0006H3.99984C3.64622 28.0006 3.30708 27.8602 3.05703 27.6101C2.80698 27.3601 2.6665 27.0209 2.6665 26.6673V5.33398C2.6665 4.98036 2.80698 4.64122 3.05703 4.39118C3.30708 4.14113 3.64622 4.00065 3.99984 4.00065H9.33317V1.33398H11.9998ZM26.6665 13.334H5.33317V25.334H26.6665V13.334ZM20.0478 14.8486L21.9332 16.734L15.3332 23.334L10.6185 18.6193L12.5065 16.734L15.3345 19.5633L20.0492 14.8486H20.0478ZM9.33317 6.66732H5.33317V10.6673H26.6665V6.66732H22.6665V8.00065H19.9998V6.66732H11.9998V8.00065H9.33317V6.66732Z",
    fill: "#E2B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.94cc6894b8e3e51417a977ab0313a353.svg";
export { ForwardRef as ReactComponent };